import { apiUrl } from "config/envConfig";
import http from "./httpService";
import { OrderTypeEnum } from "enums/shared";
import {
  DEFAULT_PAGE,
  DEFAULT_ROWS_PER_PAGE,
} from "constants/paginationConstants";

const path = "/order-mgmt/admin";
const url = apiUrl;

/**
 * Fetch issues for the dashboard with pagination and optional filtering.
 *
 * @param {number} pageSize  Number of records per page.
 * @param {number} pageNumber  Current page number.
 * @param {string} [searchBar=""]  Search term to filter issues.
 * @param {number|null} [type=null]  Optional issue type to filter by.
 * @returns {Promise<Object>} An object containing paginated issues and total record count.
 */
export const GetIssues = async (
  pageSize = DEFAULT_ROWS_PER_PAGE,
  pageNumber = DEFAULT_PAGE,
  searchBar = "",
  types = [],
  orderType = null
) => {
  let query = `?pageSize=${pageSize}&pageNumber=${pageNumber}&searchBar=${searchBar}`;
  if (types.length > 0) {
    query += types.map((type) => `&Type=${type}`).join("");
  }
  if (orderType !== null && orderType !== undefined) {
    const mappedOrderType =
      orderType === OrderTypeEnum.expedited ? 2 : 1;
    query += `&orderType=${mappedOrderType}`;
  }
  const {
    data: { data },
  } = await http.get(`${url}${path}/dashboard/issues${query}`);
  return {
    page: data.page || [],
    totalRecords: data.totalRecords || 0,
  };
};

/**
 * Fetch detailed order counts for each month.
 *
 * @returns {Promise<Object>} The data object containing monthly order counts.
 */
export const GetOrderDetailedCounts = async (orderType = null) => {
  const params = {};
  if (orderType !== null && orderType !== undefined) {
    params.orderType = orderType === OrderTypeEnum.expedited ? 2 : orderType;
  }

  const {
    data: { data },
  } = await http.get(`${url}${path}/dashboard/detailed`, { params });
  return data;
};

/**
 * Fetch summary statistics for the dashboard.
 *
 * @param {number} [orderType=0] - The order type to filter by (0 for Regular, 1 for Expedited).
 * @returns {Promise<Object>} The data object containing dashboard summary counts.
 */
export const GetDashboardCounts = async (orderType = 0) => {
  const mapped = orderType === OrderTypeEnum.expedited ? 2 : 1;
  const {
    data: { data },
  } = await http.get(`${url}${path}/dashboard/counts?orderType=${mapped}`);
  return data;
};

/**
 * remove the order from the list
 */
export const resolveIssue = async ({ issueId, resolveNote }) => {
  const {
    data: { data },
  } = await http.patch(`${url}${path}/issue/resolve`, {
    issueId,
    resolveNote,
  });
  return data;
};
